export default [
  {
    id: 'category_0801d80c',
    name: 'Fruit',
    items: ['product_c893b8b4', 'product_15ed99a3', 'product_dad54e52', 'product_7e4cd9b3']
  },
  {
    id: 'category_94fd5c17',
    name: 'Groente',
    items: ['product_15f497eb', 'product_83de30e1', 'product_a3a3aed3', 'product_2a524b45']
  },
  {
    id: 'category_4d31b9fd',
    name: 'Vlees',
    items: ['product_3a6b1190', 'product_c34102d4', 'product_cc918d84', 'product_f1a60800']
  },
  {
    id: 'category_c64fa2d8',
    name: 'Dranken',
    items: ['product_6bafd980', 'product_1e8641fc', 'product_57d977ef', 'product_d214b1ec']
  }
]



// WEBPACK FOOTER //
// ./src/data/catalog.js